
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue?macro=true";
import { default as club49jSlil1xZCTXqHABG_HAOBAhqafy9NdTccpVNqBEuAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue?macro=true";
import { default as home9nkJtIMGrjrr4BKTvvj_SFoytI1HEzXm4h9O5fgHkJ0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue?macro=true";
import { default as about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue?macro=true";
import { default as indexz2dMNciuOMoSlcMn9K8cwo_DONoXQ9t_TZXftC34Wn4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/index.vue?macro=true";
import { default as termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue?macro=true";
import { default as latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue?macro=true";
import { default as searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue?macro=true";
import { default as _91id_938T_D_O_cPxXAvNPJiuBj8bpFTHLO9v3gz9t3HkIHejkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv/[id].vue?macro=true";
import { default as indexUM73GMJl1p4vrpf69DRTExMoPbRchpPI3R8cP57ALPoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv/index.vue?macro=true";
import { default as ppvbsD4JswI_N9yDUt5jIaeABdebW6pMZKwCkWdOevam64Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv.vue?macro=true";
import { default as indexHZeX6ZeE3zfKUwzrKh3SkUPvC6xn0JBOy2_D49__lyIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/index.vue?macro=true";
import { default as indexSBtiKnnJneEZvpQJziXwsxcu_d0Snl6vebPg9r8feNoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/billing/index.vue?macro=true";
import { default as billingShD9wn1FjGl9vaWdUP9b_TIblbHd1El2mckLHyOyPUYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/billing.vue?macro=true";
import { default as deviceshhQO_2RCdCqvLy3khecdmEZq3OUUNYaCSyfEQdcSFBAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/devices.vue?macro=true";
import { default as generalxcPlEYoo4WRdG9qt_rMTWhcdAjgsT9joUguAehrPLQ4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/general.vue?macro=true";
import { default as passwordjR_IBBlZ4zegbnDwAAuUNk6fBTD3i5bRXJMjHbupGZIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/password.vue?macro=true";
import { default as _91id_937oMQE_fum19JIopDJhITHsvfpzzOLeF6rovT_8uFXOcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/[id].vue?macro=true";
import { default as indexx6JPqjb7XIeVd8gTv5HkY4eC2MY9CVM88QLrMM5raLkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/index.vue?macro=true";
import { default as _91id_93gOLDhH0CyozwfG5Vo703cfu3nrMmOAJXaFrR2HxmIoQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/buy/[id].vue?macro=true";
import { default as subscriptionCeUVC1OzAmbCSnIbvEnVBCaenXkXaslIEFMKRKrLhk4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription.vue?macro=true";
import { default as accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue?macro=true";
import { default as archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue?macro=true";
import { default as privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue?macro=true";
import { default as open_45apptVz5Zr4a2KnBImZXfrgi7MIfG9cc5KaemSbRUpSDUrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue?macro=true";
import { default as upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue?macro=true";
import { default as highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue?macro=true";
import { default as suggestedwTHUYsD6d8m3xza2LfLgCMnSmlWWFtvYTRqK8O_vcf0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/suggested.vue?macro=true";
import { default as index_1CilYDynK_9ZM0k_Ri_iF6fof4tIa9_fBd_eXuNupIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/index.vue?macro=true";
import { default as dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue?macro=true";
import { default as _91type_93bcTSuFyglhU9_0EqMS6LWLdoX7QqJwYesA8fL3DAdoEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/info/[type].vue?macro=true";
import { default as _91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue?macro=true";
import { default as recommendationRYI1aOgrw5VtjsiVSEqnSMOuhPwIK41HAT21hTWyp9UMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/recommendation.vue?macro=true";
import { default as clipsVYrOj3xclZffFlKKtRdY9OAlLpAPi8KWcizPPByhp7sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/selected/clips.vue?macro=true";
import { default as failureVbW_aedsogP7ZwvsOWcqnzHIULhosvuTv6SA9x7pTQ8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/failure.vue?macro=true";
import { default as successF4NZTfj8qgYdQ7kNPJ89_dqzo_baHaGvVKGATnfKqakMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/success.vue?macro=true";
import { default as videosTldhMytv5BJLs_nxr77Hb6fw3yBJ33uT_wuV6eq9VycMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/selected/videos.vue?macro=true";
import { default as indexEl5rDsaImBTr1gWZWCnS7g2nZBbrqGy4_SWQi0YJ2wYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/login/index.vue?macro=true";
import { default as limitlzjLi47jA62jlNyIdIHUo8LsHnsqnJ_r53hBI9qBvNgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/login/limit.vue?macro=true";
import { default as _91eventId_932uElCQYH6gyZFSeZ0palMLQWGYL5X3flb5nLVAVlH6sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/events/[eventId].vue?macro=true";
import { default as indexBDu6cSvUVpFhw28L1QeQ1nnGqAo7X__Dd5zUfsJ9zHAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/[sportType]/index.vue?macro=true";
import { default as _91sportType_93fGqDAswedUA1cy5QZWnk0mx4y5MQ1ke3ggfW1CGjz4sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/[sportType].vue?macro=true";
import { default as _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue?macro=true";
import { default as _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue?macro=true";
import { default as index6XgAdDjzsHL6TTUXtAiXvyjo9ylxr_JcoqcW0XBW7p0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/index.vue?macro=true";
import { default as _91eventId_93v2aPpU_FgjxdEf_PsFgQGMONl5lJd48kGThxFJgHG0kMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/channels/[eventId].vue?macro=true";
import { default as processingnEmsL2D1wCUQsRSbBYAD7aK_b3RsZDMKKG0Qr5e12OEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/processing.vue?macro=true";
import { default as reseta_XyHhDPoDgqKih_6tXAM6HGxD8vfgsyQpxvUIUag1oMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/password/reset.vue?macro=true";
import { default as forgotAsJyI95ZGcOz9i4u_urbcQwWcBENgC6O1ugctnwxXy4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/password/forgot.vue?macro=true";
import { default as _91eventId_93qh1oH5ZjO_04q6UW7GkxhFM4M00Vfph86Uxb0euLiYUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/events/stats/[eventId].vue?macro=true";
import { default as indexAkxatBRybc_1ytwg_lBqWZrp4Ym5ckjOYEYaZa5Uqr8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue?macro=true";
import { default as indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue?macro=true";
import { default as indexVgQ1ohbNsRxuN1B1s9JnYkTtCq0QcEYf4G_h4MR9dtsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue?macro=true";
import { default as followed_YkwRP3l0v3lJpPybeHgIZAU7iIUvLM7_imh3cd7wDEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue?macro=true";
import { default as followed3yxyN5rCAr1NBGyaeaUwYMmrzdyTZQj43uwGwpL1BgcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue?macro=true";
import { default as personalizationzKN5cayZjexo41pxefU26qXWynDID3Hkm9GUvGPmpeUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/personalization.vue?macro=true";
import { default as _91referenceId_93vHHScIcdC2Hwjw7L7ylGl_RrrhhV8kPUr47VX76SBmQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue?macro=true";
import { default as _91provider_930_nu_KLSvhsgPtHiDyrVQS6CN9WRL5z3xN3a3fQ1dkEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/oauth2/callback/[provider].vue?macro=true";
import { default as indexnbaPU_6I5Ej0W1nZ_wJg9FFzliOcRBIJvlLCcCaDrFsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/index.vue?macro=true";
import { default as index6AxA_7Akryj8WOVeqZp40sYBk8lkhOx8jiWI3NTWrsIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue?macro=true";
import { default as indexz1qtgU49Y2lcmSKWWB_BgtdTikplLh_wUY2uJoIWwrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue?macro=true";
import { default as _91id_93KbzkcCQ2t6zXefi3NJaH9mltqXDEd3VgMcor_nxLVncMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/buy/[id].vue?macro=true";
import { default as indexSGgcK3s5iU459i_s8M1ztpmUCSaLmwbJTohKCRY_C3cMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/index.vue?macro=true";
import { default as index77CgQvlSXQjRSkW_ZSTWB_8HROhIwYyj8nEtH_VLZjoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/code/index.vue?macro=true";
import { default as followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue?macro=true";
import { default as followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue?macro=true";
import { default as indexaeWYQOJQxiMbAU0n2x5gS9BADvGS2r1KMQTpPTtwZWwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/index.vue?macro=true";
import { default as followedmtDkitGf7Or4p4Y0xd5mENzIs4qPoMhQ_gSZ3BAArosMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/followed.vue?macro=true";
import { default as _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue?macro=true";
import { default as followeda6ri0NhEjHFDqICKC_4Jj2c9XtOKq4u0P9NNz0vWHsMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/followed.vue?macro=true";
import { default as index6UdZBMej0baSwr5yOhs3IvGN5orW9ytJX4qObLvIFqYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/[mainId]/index.vue?macro=true";
import { default as indexLi4dACyv8Vbw4KalPbc4l5iH3czzBtfVHaNXw7HUPvEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/[leagueId]/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue")
  },
  {
    name: "club",
    path: "/club",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexz2dMNciuOMoSlcMn9K8cwo_DONoXQ9t_TZXftC34Wn4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue")
  },
  {
    name: "latest",
    path: "/latest",
    meta: latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue")
  },
  {
    name: accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta?.name,
    path: "/account",
    meta: { ...(accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue"),
    children: [
  {
    name: ppvbsD4JswI_N9yDUt5jIaeABdebW6pMZKwCkWdOevam64Meta?.name,
    path: "ppv",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv.vue"),
    children: [
  {
    name: "account-ppv-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv/[id].vue")
  },
  {
    name: "account-ppv",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/ppv/index.vue")
  }
]
  },
  {
    name: "account",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/index.vue")
  },
  {
    name: billingShD9wn1FjGl9vaWdUP9b_TIblbHd1El2mckLHyOyPUYMeta?.name,
    path: "billing",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/billing.vue"),
    children: [
  {
    name: "account-billing",
    path: "",
    meta: { ...(indexSBtiKnnJneEZvpQJziXwsxcu_d0Snl6vebPg9r8feNoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/billing/index.vue")
  }
]
  },
  {
    name: "account-devices",
    path: "devices",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/devices.vue")
  },
  {
    name: "account-general",
    path: "general",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/general.vue")
  },
  {
    name: "account-password",
    path: "password",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/password.vue")
  },
  {
    name: subscriptionCeUVC1OzAmbCSnIbvEnVBCaenXkXaslIEFMKRKrLhk4Meta?.name,
    path: "subscription",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription.vue"),
    children: [
  {
    name: "account-subscription-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/[id].vue")
  },
  {
    name: "account-subscription",
    path: "",
    meta: { ...(indexx6JPqjb7XIeVd8gTv5HkY4eC2MY9CVM88QLrMM5raLkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/index.vue")
  },
  {
    name: "account-subscription-buy-id",
    path: "buy/:id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account/subscription/buy/[id].vue")
  }
]
  }
]
  },
  {
    name: "archive",
    path: "/archive",
    meta: archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue")
  },
  {
    name: "open-app",
    path: "/open-app",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue")
  },
  {
    name: "upcoming",
    path: "/upcoming",
    meta: upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue")
  },
  {
    name: "highlight",
    path: "/highlight",
    meta: highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue")
  },
  {
    name: "suggested",
    path: "/suggested",
    meta: suggestedwTHUYsD6d8m3xza2LfLgCMnSmlWWFtvYTRqK8O_vcf0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/suggested.vue")
  },
  {
    name: "live",
    path: "/live",
    meta: index_1CilYDynK_9ZM0k_Ri_iF6fof4tIa9_fBd_eXuNupIMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/index.vue")
  },
  {
    name: "dev-ad-test",
    path: "/dev-ad-test",
    meta: dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue")
  },
  {
    name: "info-type",
    path: "/info/:type()",
    meta: _91type_93bcTSuFyglhU9_0EqMS6LWLdoX7QqJwYesA8fL3DAdoEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/info/[type].vue")
  },
  {
    name: "team-teamId",
    path: "/team/:teamId()",
    meta: { ...(_91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta || {}), ...{"middleware":"disable-team-page"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue")
  },
  {
    name: "recommendation",
    path: "/recommendation",
    meta: { ...(recommendationRYI1aOgrw5VtjsiVSEqnSMOuhPwIK41HAT21hTWyp9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/recommendation.vue")
  },
  {
    name: "selected-clips",
    path: "/selected/clips",
    meta: { ...(clipsVYrOj3xclZffFlKKtRdY9OAlLpAPi8KWcizPPByhp7sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/selected/clips.vue")
  },
  {
    name: "payment-failure",
    path: "/payment/failure",
    meta: { ...(failureVbW_aedsogP7ZwvsOWcqnzHIULhosvuTv6SA9x7pTQ8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/failure.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: { ...(successF4NZTfj8qgYdQ7kNPJ89_dqzo_baHaGvVKGATnfKqakMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/success.vue")
  },
  {
    name: "selected-videos",
    path: "/selected/videos",
    meta: { ...(videosTldhMytv5BJLs_nxr77Hb6fw3yBJ33uT_wuV6eq9VycMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/selected/videos.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexEl5rDsaImBTr1gWZWCnS7g2nZBbrqGy4_SWQi0YJ2wYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/login/index.vue")
  },
  {
    name: "auth-login-limit",
    path: "/auth/login/limit",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/login/limit.vue")
  },
  {
    name: "events-eventId",
    path: "/events/:eventId()",
    meta: _91eventId_932uElCQYH6gyZFSeZ0palMLQWGYL5X3flb5nLVAVlH6sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/events/[eventId].vue")
  },
  {
    name: _91sportType_93fGqDAswedUA1cy5QZWnk0mx4y5MQ1ke3ggfW1CGjz4sMeta?.name,
    path: "/live/:sportType()",
    meta: _91sportType_93fGqDAswedUA1cy5QZWnk0mx4y5MQ1ke3ggfW1CGjz4sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/[sportType].vue"),
    children: [
  {
    name: "live-sportType",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/live/[sportType]/index.vue")
  }
]
  },
  {
    name: "league-leagueId",
    path: "/league/:leagueId()",
    meta: _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue")
  },
  {
    name: "sub-category-id",
    path: "/sub-category/:id()",
    meta: _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue")
  },
  {
    name: "auth-sign-up",
    path: "/auth/sign-up",
    meta: index6XgAdDjzsHL6TTUXtAiXvyjo9ylxr_JcoqcW0XBW7p0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/index.vue")
  },
  {
    name: "channels-eventId",
    path: "/channels/:eventId()",
    meta: _91eventId_93v2aPpU_FgjxdEf_PsFgQGMONl5lJd48kGThxFJgHG0kMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/channels/[eventId].vue")
  },
  {
    name: "payment-processing",
    path: "/payment/processing",
    meta: { ...(processingnEmsL2D1wCUQsRSbBYAD7aK_b3RsZDMKKG0Qr5e12OEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/payment/processing.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/password/reset.vue")
  },
  {
    name: "auth-password-forgot",
    path: "/auth/password/forgot",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/password/forgot.vue")
  },
  {
    name: "events-stats-eventId",
    path: "/events/stats/:eventId()",
    meta: _91eventId_93qh1oH5ZjO_04q6UW7GkxhFM4M00Vfph86Uxb0euLiYUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/events/stats/[eventId].vue")
  },
  {
    name: "following-league",
    path: "/following/league",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue")
  },
  {
    name: "category-mainId",
    path: "/category/:mainId()",
    meta: indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue")
  },
  {
    name: "following-category",
    path: "/following/category",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue")
  },
  {
    name: "following-league-followed",
    path: "/following/league/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue")
  },
  {
    name: "following-category-followed",
    path: "/following/category/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue")
  },
  {
    name: "auth-sign-up-personalization",
    path: "/auth/sign-up/personalization",
    meta: { ...(personalizationzKN5cayZjexo41pxefU26qXWynDID3Hkm9GUvGPmpeUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/personalization.vue")
  },
  {
    name: "redirect-events-referenceId",
    path: "/redirect/events/:referenceId()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue")
  },
  {
    name: "auth-oauth2-callback-provider",
    path: "/auth/oauth2/callback/:provider()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/oauth2/callback/[provider].vue")
  },
  {
    name: "auth-sign-up-subscription",
    path: "/auth/sign-up/subscription",
    meta: { ...(indexnbaPU_6I5Ej0W1nZ_wJg9FFzliOcRBIJvlLCcCaDrFsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/index.vue")
  },
  {
    name: "following-category-mainId",
    path: "/following/category/:mainId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue")
  },
  {
    name: "following-league-leagueId",
    path: "/following/league/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue")
  },
  {
    name: "auth-sign-up-subscription-buy-id",
    path: "/auth/sign-up/subscription/buy/:id()",
    meta: _91id_93KbzkcCQ2t6zXefi3NJaH9mltqXDEd3VgMcor_nxLVncMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/buy/[id].vue")
  },
  {
    name: "auth-sign-up-following-league",
    path: "/auth/sign-up/following/league",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/index.vue")
  },
  {
    name: "auth-sign-up-subscription-code",
    path: "/auth/sign-up/subscription/code",
    meta: { ...(index77CgQvlSXQjRSkW_ZSTWB_8HROhIwYyj8nEtH_VLZjoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/subscription/code/index.vue")
  },
  {
    name: "following-category-mainId-followed",
    path: "/following/category/:mainId()/followed",
    meta: { ...(followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue")
  },
  {
    name: "following-league-leagueId-followed",
    path: "/following/league/:leagueId()/followed",
    meta: { ...(followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue")
  },
  {
    name: "auth-sign-up-following-category",
    path: "/auth/sign-up/following/category",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/index.vue")
  },
  {
    name: "auth-sign-up-following-league-followed",
    path: "/auth/sign-up/following/league/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/followed.vue")
  },
  {
    name: "category-mainId-sub-category-subId",
    path: "/category/:mainId()/sub-category/:subId()",
    meta: _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue")
  },
  {
    name: "auth-sign-up-following-category-followed",
    path: "/auth/sign-up/following/category/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/followed.vue")
  },
  {
    name: "auth-sign-up-following-category-mainId",
    path: "/auth/sign-up/following/category/:mainId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/category/[mainId]/index.vue")
  },
  {
    name: "auth-sign-up-following-league-leagueId",
    path: "/auth/sign-up/following/league/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/auth/sign-up/following/league/[leagueId]/index.vue")
  }
]